<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit :key="componentKey" :mode="mode" @back="backToList" @save="saveData" :triggerSave.sync="triggerSave"
          :model="models" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Car For Sell',to: '/admin/list-car_for_sell' },
        { label: '' }
      ],
      users: null,
      validationErrors: [],
      title: "Create A New Car For Sell",
      mode: 'add',
      models: {},
      modelsColor: {},
      modelsCarSellSlug: {},
      componentKey: 1,
      accountID: '',
      page_transaction: null,
      active_check: true,
      users_clubs_id: '',
      numberCarSellAuto : [],
      time_zone_local: moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted() {
   
    
    console.log("this.$route.name:", this.$route.query.page_transaction);
    this.mode = this.$route.name === 'edit' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    this.items_bread_crumb[1].label = this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CAR_FOR_SELL);
    if (this.mode == 'edit') {
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    } else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    }
    this.componentKey = (new Date()).getTime();
    console.log("this.componentKeythis.componentKey:", this.componentKey)
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-car_for_sell' });
    },
    UpdateActive(key) {
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if (key == 'lock') {
        this.active_check = false
      } else {
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': { '_eq': this.$route.params.id }
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success', res);
        if (key == 'lock') {
          var query_t = `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    tringToSlug(str) {
      return str
        .toLowerCase() 
        .trim() 
        .replace(/[\s\W-]+/g, '-')
        .replace(/^-+|-+$/g, '');
    },
    async saveData(params) {
      console.log('gia tri cua parama' + params.status)
      if (params.status == 1 ) {
        params.status = 'FOR_SELL';
      } else if (params.status == 2) {
        params.status = 'SOLD_OUT_SELL';
      } else if (params.status == 3) {
        params.status = 'CANCEL_SELL';
      }
      let objects = {
        name: params.color_id ?? null,
      };
      var list_file = params?.list_file ?? [];
      var list_file_cover = params?.list_file_cover ?? [];
      var list_file_cover_edit = params?.list_file_cover_edit ?? [];
      
      var list_id_file_delete = params?.list_id_file_delete ?? [];
      var list_id_file_delete_cover = params?.list_id_file_delete_cover ?? [];
      
      this.triggerSave = false;


      var nameConvertSlug = this.tringToSlug(params.name)
      var auto_in_number = await this.getNextAutoInNumber();
      console.log('nameConvertSlug',nameConvertSlug);
      if (this.mode === 'add') {
      
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;

        try {
          let existingColor = await this.getDataColor(params.color_id);

          let resColor;
          if (existingColor && existingColor.name !== params.color_id) {
            console.log('debug1',existingColor);
              resColor = await this.$apollo.mutate({
              mutation: DataServices.insertData('color'),
              variables: {
                objects: objects
              }
            });
          } else if (existingColor.name === params.color_id) {
            console.log('ko ton tai mau nay');
              resColor = await this.$apollo.mutate({
              mutation: DataServices.updateData('color'),
              variables: {
                'data_update': objects,
                'where_key': {
                  'name': { '_eq': params.color_id }
                }
              }
            });
          }

          // kiểm tra auto_in_number
          // let existingNumberAuto = await this.getNumberAuto();
          // existingNumberAuto = this.numberCarSellAuto.car_for_sell[0].auto_in_number;
     
          
          let returningColor = resColor.data[Object.keys(resColor.data)].returning[0];
          let resCar = await this.$apollo.mutate({
            mutation: DataServices.insertData('car_for_sell'),
            variables: {
              objects: {
                status: params?.status ?? null,
                code: params?.code ?? null,
                name: params?.name ?? "",
                plate_number: params?.plate_number ?? null,
                price_before: params?.price_before ?? null,
                price: params?.price ?? null,
                showroom_id: params?.showroom_id ?? 0,
                make_vehicle_category_id: params?.make_vehicle_category_id ?? null,
                model: params?.model ?? null,
                build: params?.build ?? null,
                color_id: returningColor.id ?? null,
                type: params?.type ?? null,
                odometer: parseFloat(params?.odometer) ?? 0,
                fuel_type_id: params?.fuel_type_id ?? null,
                battery_capacity: params?.battery_capacity ?? null,
                transmission_id: params?.transmission_id ?? null,
                finance_id: params?.finance_id ?? null,
                rego_validation: params?.rego_validation ?? null,              
                description: params?.description ?? null,
                url_video: params?.url_video ?? null,
                new: params?.new ?? null,
                alt: params?.alt ?? null,
                total_view : 0,
                slug: `${nameConvertSlug}-${auto_in_number + 1}`,
                // auto_in_number : existingNumberAuto + 1 ?? null,
                active: params?.active ?? null,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                created_by: this.$store.getters.user,
                auto_in_number : auto_in_number + 1
              },
            }
          });

          let returningCar = resCar.data[Object.keys(resCar.data)].returning[0];

          try {
            var data = await ApiRepository.post('/_api/sitemap/add_sitemap', {
              url: `buy/${nameConvertSlug}-${auto_in_number + 1}`,
              type: 'dynamic',
              obj_id: returningCar.id,
              priority: 0.5,
              changefreq: 'weekly',
              lastmod: moment.tz(new Date(), this.time_zone_local).format('YYYY-MM-DD HH:mm:ss'),
              uid_admin: this.$store.getters.user
            });
            console.log('Sitemap added successfully:', data);
            
          } catch (error) {
            console.log('Error adding to sitemap:', error);
          }

          // Upload file nếu có
          if (list_file.length > 0) {
            let resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_SELL_NORMAL, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                let objectImage = resImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_SELL_NORMAL, returningCar.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }

          // Upload ảnh bìa nếu có
          if (list_file_cover.length > 0) {
            let resImageCover = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_SELL_AVARTAR, list_file_cover);
            if (resImageCover && resImageCover.length > 0) {
              for (let i = 0; i < resImageCover.length; i++) {
                let objectImage = resImageCover[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_SELL_AVARTAR, returningCar.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }

          this.redirectEdit();

        } catch (error) {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
          this.$commonFuction.is_loading(false);
        }
      }
      else if (this.mode === 'edit') {
        console.log('nnnnnnnnnnnnnnnnnnnnnnnnnn',params.color_id);
        
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        try {
          let existingColor = await this.getDataColor(params.color_id);
          console.log('existingColor',existingColor.name);
          let resColor;
          if (existingColor && existingColor.name !== params.color_id) {
            console.log('debug1',existingColor);
              resColor = await this.$apollo.mutate({
              mutation: DataServices.insertData('color'),
              variables: {
                objects: objects
              }
            });
          } else if (existingColor.name === params.color_id) {
            console.log('ko ton tai mau nay');
              resColor = await this.$apollo.mutate({
              mutation: DataServices.updateData('color'),
              variables: {
                'data_update': objects,
                'where_key': {
                  'name': { '_eq': params.color_id }
                }
              }
            });
          }
          // Xử lý tiếp theo nếu cập nhật thành công color
          let returningColor = resColor.data[Object.keys(resColor.data)].returning[0];

          console.log('returningColorreturningColor',returningColor);
          
          let resCar = await this.$apollo.mutate({
            mutation: DataServices.updateData('car_for_sell'),
            variables: {
              'data_update': {
                status: params?.status ?? null,
                code: params?.code ?? null,
                name: params?.name ?? "0",
                plate_number: params?.plate_number ?? null,
                price_before: params?.price_before ?? null,
                price: params?.price ?? null,
                showroom_id: params?.showroom_id ?? 0,
                make_vehicle_category_id: params?.make_vehicle_category_id ?? null,
                model: params?.model ?? null,
                build: params?.build ?? null,
                color_id: returningColor.id ?? null,
                type: params?.type ?? null,
                odometer: params?.odometer ?? null,
                fuel_type_id: params?.fuel_type_id ?? null,
                finance_id: params?.finance_id ?? null,
                battery_capacity: params?.battery_capacity ?? null,
                transmission_id: params?.transmission_id ?? null,
                rego_validation: params?.rego_validation ?? null,    
                description: params?.description ?? null,
                url_video: params?.url_video ?? null,
                new: params?.new ?? null,
                alt: params?.alt ?? null,
                active: params?.active ?? null,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
                slug: `${nameConvertSlug}-${params?.auto_in_number }`,
              },
              'where_key': {
                'id': { '_eq': this.models.id }
              }
            }
          });

          let returningCar = resCar.data[Object.keys(resCar.data)].returning[0];

          try {
              await ApiRepository.post('/_api/sitemap/add_sitemap', {
              url: `buy/${nameConvertSlug}-${params?.auto_in_number }`,
              type: 'dynamic',
              obj_id: this.models.id,
              priority: 0.5,
              changefreq: 'weekly',
              lastmod: moment.tz(new Date(), this.time_zone_local).format('YYYY-MM-DD HH:mm:ss'),
              uid_admin: this.$store.getters.user
            });
          } catch (error) {
            console.log('Error adding to sitemap:', error);
          }

          console.log('params.list_id_file_delete',params.list_id_file_delete);
          console.log('params.list_id_file_delete',params.list_id_file_delete_cover);
          if (list_id_file_delete.length > 0){
              await this.$CoreService.deleteDataImageMulti(this.$constants.TYPE_IMAGE.CAR_SELL_NORMAL, list_id_file_delete)
          }
          if (list_id_file_delete_cover.length > 0){
              await this.$CoreService.deleteDataImageMulti(this.$constants.TYPE_IMAGE.CAR_SELL_NORMAL, list_id_file_delete_cover)
          }
          // Xử lý upload file
          if (list_file.length > 0) {
            const resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_SELL_NORMAL, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                var objectImage = resImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_SELL_NORMAL, returningCar.id, objectImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }
          
          if (list_id_file_delete_cover.length > 0) {
              await  this.$CoreService.deleteDataImage(this.$constants.TYPE_IMAGE.CAR_SELL_AVARTAR, returningCar.id);
            }
          if (list_file_cover.length > 0) {
            if (list_file_cover_edit.length > 0) {
              await this.$CoreService.deleteDataImage(this.$constants.TYPE_IMAGE.CAR_RENT_AVARTAR, this.models.id);
            }
            const resCoverImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CAR_SELL_AVARTAR, list_file_cover);
            if (resCoverImage && resCoverImage.length > 0) {
              for (let i = 0; i < resCoverImage.length; i++) {
                var coverImage = resCoverImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.CAR_SELL_AVARTAR, returningCar.id, coverImage).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }

          this.redirectEdit(); // Sau khi xử lý thành công, chuyển hướng

        } catch (error) {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
        }
      }

      this.$commonFuction.is_loading(false);


      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = { path: '/admin/list-car_for_sell' };
      that.$commonFuction.is_loading(false);
      if (that.mode == 'add') {
        that.$router.push(router_back);
      } else {
        if (!that.$commonFuction.isEmpty(router_back)) {
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var { data } = await this.$apollo.query({
        query: DataServices.getList('car_for_sell'),
        variables: {
          where_key: {
            id: { '_eq': id }
          }
        },
        fetchPolicy: "network-only"
      })
      console.log("datadata:", data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var dataImage = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.CAR_SELL_AVARTAR], [this.models.id]);
        var dataImageList = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.CAR_SELL_NORMAL], [this.models.id]);

        this.models["list_file_edit"] = dataImage.listData;
        this.models["list_file_edit_normal"] = dataImageList.listData;

      }
      this.componentKey++;
    },
    async getDataColor(name) {
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList('color'),
          variables: {
            where_key: {
              name: { _eq: name }
            }
          },
          fetchPolicy: "network-only"
        });
        if (data && data.color && data.color.length > 0) {
          this.modelsColor = data.color[0];
        }
        return this.modelsColor;
      } catch (error) {
        return null;
      }
    },
    async getNextAutoInNumber() {
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList('car_for_sell'),
          variables: {
            where_key: {  },
            orderBy: { auto_in_number: 'desc' },
            limit: 1
          },
          fetchPolicy: "network-only"
        });
        const maxAutoInNumber = data.car_for_sell.length > 0 ? data.car_for_sell[0].auto_in_number : 0;
        return maxAutoInNumber;
      } catch (error) {
        console.error('Error fetching the largest auto_in_number:', error);
        return 1; 
      }
    },
    async getNumberAuto() {
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList('car_for_sell'),
          variables: {
            where_key: {deleted : { _eq : false }},
            orderBy: { auto_in_number: 'desc' },
            limit: 1 
          },
          fetchPolicy: "network-only"
        });
        return data;
      } catch (error) {
        console.error('Error fetching the largest auto_in_number:', error);
        return null;
      }
    }


  },
  apollo: {

  }
}
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px !important;
  /* margin-bottom: 16px; */
  padding-bottom: 20px;
  /* border-bottom: 1px solid #EEEEEE; */
  font-weight: 700;
  margin-left: 20px;
}

.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only {
      padding: 0 !important;
    }
  }
}

.note {
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 24px;
  padding-top: 10px;
}

.p-formgrid {
  margin: 0;

  .p-panel-header {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    background: #EEEEEE;
  }

  .p-card-field {
    padding: 24px;

    .p-field {
      .p-col-fixed {
        width: 300px;
        display: inline-block !important;
        margin: 0;
      }

      .p-col-width {
        width: 500px !important;
        border-radius: 5px;

        &.disabled {
          background: #EEEEEE;
          border: 0 none;
          padding: 8px 10px;
        }

        .file-select {
          margin: 0;

          input[type="file"] {
            display: none;
          }

          .select-button {
            display: inline-block;
            cursor: pointer;
            background: transparent;
            border-radius: 5px;
            color: #000000;
            font-size: 13px;
            padding: 3px 16px;
            border: 1px solid #B4B4B4;
          }
        }

        &.pac-target-input {
          height: 80px;
          word-break: break-all;
          overflow-wrap: break-word;
          resize: none;
        }
      }

      .box-images {
        margin: 0;
        margin-top: 10px;
        position: relative;

        .item-img {
          width: 150px;
          height: 150px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: inline-flex;
          position: relative;

          img {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
            object-fit: contain;
            padding: 5px;
          }

          .button-clear {
            border-radius: 10px;
            width: 24px;
            height: 24px;
            background: #F5564E;
            float: right;
            cursor: pointer;
            position: absolute;
            right: 0px;

            img {
              vertical-align: top;
            }
          }
        }
      }

      .p-invalid {
        display: block;
      }
    }
  }

  .fixed-bottom-toolbar {
    background: transparent;
    border: 0 none;
    margin-top: 22px;
    border-top: 1px solid #B4B4B4;
    padding: 0;
    padding-top: 30px;

    .p-button {
      width: auto;
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.manager-title-row {
  border-bottom: 1px solid #EEEEEE;
}

.p-toolbar-group-right {
  flex-basis: 30%;
}

.p-button-warning.p-button {
  margin: 0 10px;
}
</style>
